@if (isRmbRmc && exported) {
<p>{{ "OTHER_COVERAGE_STATICTEXT14" | globalTranslate }}</p>
} @if (getValue('extras.topLevelAnswer') === 'YES') {
<div form-top>
  <h1 class="person-label" [attr.aria-hidden]="!selectedIndividual ? 'true' : null">
    {{ selectedIndividual | fullname }}
  </h1>
</div>
}
<nh-form
  [topLevelName]="'seem'"
  [individuals]="individuals"
  [formGroup]="getForm()"
  [mode]="mode"
  topLevelQuestion="{{ 'SELF_EMPLOYMENT_STATIC_TEXT1' | globalTranslate }}"
  individualQuestion="{{ 'SELF_EMPLOYMENT_STATIC_TEXT2' | globalTranslate }}"
  [hintText]="hintText"
  (validate)="onValidate($event)"
  class="label-section"
>
  <div [formGroup]="getControl('data')">
    <br />
    <h2 class="section-header">
      {{ "SELF_EMPLOYMENT_STATIC_TEXT3" | globalTranslate }}
    </h2>
    <hr />

    <nh-field
      id="seem_businessName"
      [mandatory]="false"
      [attr.aria-required]="false"
      label="{{ 'SELF_EMPLOYMENT_STATIC_TEXT4' | globalTranslate }}"
      class="label-section"
    >
      <input
        type="text"
        name="businessName"
        [attr.aria-label]="'SELF_EMPLOYMENT_STATIC_TEXT4' | globalTranslate"
        maxlength="50"
        class="form-control"
        formControlName="businessName"
      />
    </nh-field>

    <nh-field
      id="seem_type"
      label="{{ 'SELF_EMPLOYMENT_STATIC_TEXT5' | globalTranslate }} {{
        selectedIndividual | fullname
      }}{{ 'SELF_EMPLOYMENT_STATIC_TEXT6' | globalTranslate }}"
      class="label-section"
    >
      <select
        nhTranslate
        name="type"
        aria-required="true"
        [attr.aria-label]="
          ('SELF_EMPLOYMENT_STATIC_TEXT5' | globalTranslate) +
          ' ' +
          (selectedIndividual | fullname) +
          ' ' +
          ('SELF_EMPLOYMENT_STATIC_TEXT6' | globalTranslate)
        "
        (change)="onSelfEmpTypeChange()"
        [items]="tableCodeValue('SELFEMPTYPE', 'data.type')"
        formControlName="type"
      ></select>
    </nh-field>

    @if (showBusinessDesc) {
    <nh-field
      id="seem_businessDescription"
      label="{{ 'SELF_EMPLOYMENT_STATIC_TEXT7' | globalTranslate }}"
      class="label-section"
    >
      <input
        type="text"
        name="businessDescription"
        maxlength="50"
        class="form-control"
        formControlName="businessDescription"
        [attr.aria-label]="'SELF_EMPLOYMENT_STATIC_TEXT7' | globalTranslate"
      />
    </nh-field>
    }

    <nh-field
      id="seem_averageMonthlyProfit"
      label="{{ 'SELF_EMPLOYMENT_STATIC_TEXT8' | globalTranslate }} {{
        selectedIndividual | fullname
      }} {{ 'SELF_EMPLOYMENT_STATIC_TEXT9' | globalTranslate }}"
      class="label-section"
    >
      <nh-input-group prepend="$">
        <input
          nh
          type="text"
          aria-required="true"
          placeholder="0.00"
          mask="separator.2"
          thousandSeparator=""
          separatorLimit="999999999"
          name="averageMonthlyProfit"
          [attr.aria-label]="
            ('SELF_EMPLOYMENT_STATIC_TEXT8' | globalTranslate) +
            ' ' +
            (selectedIndividual | fullname) +
            ' ' +
            ('SELF_EMPLOYMENT_STATIC_TEXT9' | globalTranslate)
          "
          formControlName="averageMonthlyProfit"
          class="form-control"
        />
      </nh-input-group>
    </nh-field>

    <h2 class="section-header">{{ "CO-OWENERS_TITLE" | globalTranslate }}</h2>
    <hr />
    <nh-field
      id="seem_anyOneOutside"
      label="{{ 'CO-OWENERS_STATIC_TEXT1' | globalTranslate }} {{
        selectedIndividual | fullname
      }}?  "
      class="label-section"
    >
      <div class="hint">
        {{ "CO-OWENERS_STATIC_TEXT2" | globalTranslate }}
        {{ selectedIndividual | fullname }}
        {{ "CO-OWENERS_STATIC_TEXT3" | globalTranslate }}
      </div>
      <select
        nhTranslate
        name="anyOneOutside"
        aria-required="true"
        [attr.aria-label]="
          ('CO-OWENERS_STATIC_TEXT1' | globalTranslate) +
          ' ' +
          (selectedIndividual | fullname)
        "
        (change)="onAnyOneOutSideChange()"
        [items]="tableCodeValue('YESNO', 'data.anyOneOutside')"
        formControlName="anyOneOutside"
      ></select>
    </nh-field>

    @if (isY('data.anyOneOutside')) {
    <div class="d-none d-lg-block">
      <table class="table w-100 table-striped">
        <thead>
          <tr>
            <th scope="col">{{ "CO-OWENERS_HEADER1" | globalTranslate }}</th>
            <th scope="col">{{ "CO-OWENERS_HEADER2" | globalTranslate }}</th>
            <th scope="col">{{ "CO-OWENERS_HEADER3" | globalTranslate }}</th>
            <th scope="col">
              <span class="visually-hidden">{{
                "ACTIONS" | globalTranslate
              }}</span>
            </th>
          </tr>
        </thead>
        <tbody formArrayName="coOwners">
          @for (row of coOwners.controls; track row; let i = $index; let isLast
          = $last) {
          <tr [formGroupName]="i">
            <td>
              @if (i == 0) {
              <nh-field
                id="{{ 'coOwnerIndividual' + i }}"
                [isRow]="true"
                [mandatory]="true"
                [attr.aria-required]="true"
              >
                <select
                  nh
                  name="coOwnerIndividual"
                  [attr.aria-label]="'CO-OWENERS_HEADER1' | globalTranslate"
                  (change)="coOwnerValidate(row)"
                  [items]="coOwnerIndividuals"
                  disabled
                  formControlName="coOwnerIndividual"
                ></select>
                @if (getControl('coOwnerIndividual', row).errors &&
                getControl('coOwnerIndividual', row).errors.INVALID_INDIV) {
                <div class="error-messages position-relative">
                  <span class="form-text invalid-tooltip d-block">
                    <ng-container>
                      {{ error.errorMessage | globalTranslate }}</ng-container
                    >
                  </span>
                </div>
                }
              </nh-field>
              } @if (i != 0) {
              <nh-field
                id="{{ 'seem_coOwnerIndividual' + i }}"
                [isRow]="true"
                [mandatory]="true"
                [attr.aria-required]="true"
              >
                <select
                  nh
                  name="coOwnerIndividual"
                  [attr.aria-label]="'CO-OWENERS_HEADER1' | globalTranslate"
                  (change)="coOwnerValidate(row)"
                  [items]="coOwnerIndividuals"
                  formControlName="coOwnerIndividual"
                ></select>
                @if (getControl('coOwnerIndividual', row).errors &&
                getControl('coOwnerIndividual', row).errors.INVALID_INDIV) {
                <div class="error-messages position-relative">
                  <span class="form-text invalid-tooltip d-block">
                    <ng-container>
                      {{ error.errorMessage | globalTranslate }}</ng-container
                    >
                  </span>
                </div>
                }
              </nh-field>
              }
            </td>
            <td>
              <nh-field
                id="{{ 'seem_outsideTheHomeFullName' + i }}"
                [isRow]="true"
                [mandatory]="true"
                [attr.aria-required]="true"
                [option]="{ label: 'Co-Owner Outside the Home' }"
              >
                <input
                  type="text"
                  name="outsideTheHomeFullName"
                  [attr.aria-label]="'CO-OWENERS_HEADER2' | globalTranslate"
                  maxlength="35"
                  class="form-control"
                  formControlName="outsideTheHomeFullName"
                />
              </nh-field>
            </td>
            <td>
              <nh-field
                id="{{ 'seem_ownershipPercentage' + i }}"
                [isRow]="true"
                [mandatory]="true"
                [attr.aria-required]="true"
              >
                <nh-input-group prepend="%">
                  <input
                    name="ownershipPercentage"
                    percentage="true"
                    type="text"
                    maxlength="3"
                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                    class="form-control"
                    [attr.aria-label]="'CO-OWENERS_HEADER3' | globalTranslate"
                    formControlName="ownershipPercentage"
                    (change)="getErrorMessage(row)"
                  />
                </nh-input-group>
                @if (data.errors?.error && isLast && error.isError) {
                <div class="error-messages position-relative">
                  <span class="form-text invalid-tooltip d-block">
                    <ng-container>
                      {{ error.errorMessage | globalTranslate }}</ng-container
                    >
                  </span>
                </div>
                }
              </nh-field>
            </td>
            <td>
              @if (i) {
              <div class="pt-1 hover-red">
                <button
                  class="btn btn-link btn-lg delete-{{ i }} hover-red p-1"
                  (click)="removeRow(i)"
                >
                  <span class="pe-2">{{ "REMOVE" | globalTranslate }}</span>
                  <nh-remove-svg></nh-remove-svg>
                </button>
              </div>
              }
            </td>
          </tr>
          }
        </tbody>
      </table>
      <div class="pt-1 hover-red add-another-left">
        <button
          [disabled]="isAddButtonEnabled()"
          class="btn btn-link btn-lg hover-red"
          (click)="addRow()"
        >
          <span class="pe-2">{{ "ADD_2" | globalTranslate }}</span>
          <nh-add-svg></nh-add-svg>
        </button>
      </div>
    </div>
    } @if (isY('data.anyOneOutside')) {
    <div class="nh-table-mobile mt-3 pt-2 d-lg-none">
      <div formArrayName="coOwners">
        @for (row of coOwners.controls; track row; let i = $index; let isLast =
        $last) {
        <div class="table-row mb-3 pb-3" [formGroupName]="i">
          <!-- <div *ngIf="translatedLang === 'en'">
                        <div class="tab-section" *ngIf="row.value.coOwnerIndividual !== null">{{ row.value.coOwnerIndividual.value}}'s Co-Ownership</div>
                      </div>
                      <div *ngIf="translatedLang !== 'en'">
                        <div class="tab-section" *ngIf="row.value.coOwnerIndividual !== null">Copropietario de {{ row.value.coOwnerIndividual.value}}</div>
                      </div> -->
          <div class="mobile-table-header">
            {{ "CO-OWENERS_HEADER1" | globalTranslate }}
          </div>
          <hr />
          <div class="mobile-table-data">
            <nh-field
              id="{{ 'coOwnerIndividual' + i }}"
              [mandatory]="true"
              [attr.aria-required]="true"
            >
              <select
                nh
                name="coOwnerIndividual"
                [attr.aria-label]="'CO-OWENERS_HEADER1' | globalTranslate"
                (change)="coOwnerValidate(row)"
                [items]="coOwnerIndividuals"
                formControlName="coOwnerIndividual"
              ></select>
            </nh-field>
          </div>
          <br />
          <div class="mobile-table-header">
            {{ "CO-OWENERS_HEADER2" | globalTranslate }}
          </div>
          <hr />
          <div class="mobile-table-data">
            <nh-field
              id="{{ 'outsideTheHomeFullName' + i }}"
              [mandatory]="true"
              [attr.aria-required]="true"
            >
              <input
                type="text"
                name="outsideTheHomeFullName"
                [attr.aria-label]="'CO-OWENERS_HEADER2' | globalTranslate"
                maxlength="35"
                class="form-control"
                formControlName="outsideTheHomeFullName"
              />
            </nh-field>
          </div>
          <br />
          <div class="mobile-table-header">
            {{ "CO-OWENERS_HEADER3" | globalTranslate }}
          </div>
          <hr />
          <div class="mobile-table-data">
            <nh-field
              id="{{ 'ownershipPercentage' + i }}"
              [isRow]="true"
              [mandatory]="true"
              [attr.aria-required]="true"
            >
              <nh-input-group prepend="%">
                <input
                  name="ownershipPercentage"
                  percentage="true"
                  type="text"
                  onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  class="form-control"
                  (change)="getErrorMessage(row)"
                  [attr.aria-label]="'CO-OWENERS_HEADER3' | globalTranslate"
                  formControlName="ownershipPercentage"
                  maxlength="3"
                />
              </nh-input-group>
              @if (data.errors?.error && isLast && error.isError) {
              <div class="error-messages position-relative">
                <span class="form-text invalid-tooltip d-block">
                  <ng-container>
                    {{ error.errorMessage | globalTranslate }}</ng-container
                  >
                </span>
              </div>
              }
            </nh-field>
          </div>
          <br />
          @if (i) {
          <div class="pt-1 hover-red text-center">
            <button
              class="btn btn-link btn-lg delete-{{ i }} hover-red p-1"
              (click)="removeRow(i)"
            >
              <span class="pe-2">{{ "REMOVE" | globalTranslate }}</span>
              <nh-remove-svg></nh-remove-svg>
            </button>
          </div>
          }<br />
        </div>
        }
      </div>
      <div class="pt-1 hover-red text-start">
        <button
          [disabled]="isAddButtonEnabled()"
          class="btn btn-link btn-lg hover-red"
          (click)="addRow()"
        >
          <span class="pe-2">{{ "ADD_2" | globalTranslate }}</span>
          <nh-add-svg></nh-add-svg>
        </button>
      </div>
    </div>
    }
  </div>
</nh-form>